import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useRefundStats(data = {}) {
  const { enabled = false } = data;
  const { privateFetch } = useContext(FetchContext);

  const getRefundStats = () => privateFetch.get('/v1/admin/refunds/stats');

  return useQuery('refund-stats', getRefundStats, { enabled });
}

export default useRefundStats;
